<mat-sidenav-container hasBackdrop="true" class="flex w-full flex-auto flex-col">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>
          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>
                Control de inicio y cierre de viajes. Permite
                ver qué rutas ya iniciaron o terminaron su jornada
                y si hay incidencias. Úsalo para asegurar
                cumplimiento de horarios y cobertura.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Estado de Viajes
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Monitorea los <b>viajes</b> permitiendo activar y cerrar los existentes en el APP.
        </div>
      </div>
      <div class="relative flex flex-0 flex-col py-2 px-4 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex flex-0 flex-col py-2 md:px-4 sm:flex-row sm:items-center sm:justify-between">
          <app-status-filters class="mr-2" [selectedTripStatuses]="selectedTripStatuses"
            [showTripStatuses]="[TripStatus.ABIERTO, TripStatus.CARGANDO, TripStatus.EN_PROCESO, TripStatus.CERRADO, TripStatus.LIQUIDANDO, TripStatus.FINALIZADO, TripStatus.DOC_LIQUIDACION_CREADO, TripStatus.DOC_LIQUIDACION_APROBADO]" 
            [tripStatusOptions]="tripStatusOptions"
            [typeFilter]="'tripStatus'" (selectionFilterApply)="onTripStatusFilterChange()">
          </app-status-filters>

          <!-- Filtro por Función de Ruta -->
          <app-status-filters class="mr-2" [selectedRouteFunction]="selectedRouteFunction" [showRouteFunction]="true"
            [routeFunctionOptions]="routeFunctionOptions" [typeFilter]="'routeFunction'"
            (selectionFilterApply)="onRouteFunctionFilterChange()">
          </app-status-filters>

          <app-status-filters class="mr-2" [modeTreeMonitor]="modeTreeTrip" [typeFilter]="'master'"
            [showTreeModeMonitor]="true" (selectionFilterApply)="findAllWithCountTree()"
            (selectionFilterApplyTree)="onChangePointTree($event)">
          </app-status-filters>
          <!-- <div class="flex flex-row justify-between items-center">
              <mat-form-field class="fuse-mat-dense fuse-mat-rounded min-w-64 mx-6 w-80 my-1" subscriptSizing="dynamic">
                <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_solid:magnifying-glass"></mat-icon>
                <input matInput placeholder="Buscar" autocomplete="off" (input)="onSearchChange($event)" />
              </mat-form-field>
            </div> -->

          <!-- Actions -->
          <div class="mt-6 flex shrink-0 items-center justify-center space-x-3 sm:ml-auto sm:mt-0">
            <!-- Agregar viaje -->
            <!-- Show filters button -->
            <!-- <button mat-stroked-button color="primary" matTooltip="Mostrar filtros" (click)="sidenav.toggle()">
                <div class="flex items-center">
                  <div class="pr-2">
                    <mat-icon svgIcon="filter_list"></mat-icon>
                  </div>
                  <div class="flex flex-col p-2 content-center text-center gap-[3px] min-w-[60px]">
                    <span>Filtrar por</span>
                  </div>
                </div>
              </button> -->
            <button mat-icon-button color="primary" [matMenuTriggerFor]="filterMenu" matTooltip="Información">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
            <button mat-icon-button color="primary" (click)="openCreateModal()" matTooltip="Nuevo registro">
              <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
            </button>
            <mat-menu #filterMenu="matMenu">
              <button mat-menu-item [matMenuTriggerFor]="statusMenu">
                <span>Estados</span>
              </button>
            </mat-menu>
            <mat-menu #statusMenu="matMenu">
              <button mat-menu-item>
                <mat-icon svgIcon="heroicons_solid:check-circle" style="color:rgb(65, 106, 218)"></mat-icon>
                <span>Abierto</span>
              </button>
              <button mat-menu-item>
                <mat-icon svgIcon="heroicons_solid:x-circle" style="color:rgb(141, 19, 19)"></mat-icon>
                <span>Liquidando</span>
              </button>
              <button mat-menu-item>
                <mat-icon svgIcon="heroicons_solid:check-circle" style="color:rgb(19, 41, 141)"></mat-icon>
                <span>Doc. Liquidación creado</span>
              </button>
              <button mat-menu-item>
                <mat-icon svgIcon="heroicons_solid:check-circle" style="color:rgb(17, 125, 49)"></mat-icon>
                <span>Doc. Liquidación aprobado</span>
              </button>
              <button mat-menu-item>
                <mat-icon svgIcon="heroicons_solid:clock" style="color:rgb(233, 124, 61)"></mat-icon>
                <span>En proceso</span>
              </button>
              <button mat-menu-item>
                <mat-icon svgIcon="heroicons_solid:check-circle" style="color:rgb(9, 133, 50)"></mat-icon>
                <span>Finalizado</span>
              </button>
              <button mat-menu-item>
                <mat-icon svgIcon="heroicons_solid:x-circle" style="color:rgb(80, 77, 77)"></mat-icon>
                <span>Cerrado</span>
              </button>
              <button mat-menu-item>
                <mat-icon svgIcon="heroicons_solid:clock" style="color:rgb(236, 199, 58)"></mat-icon>
                <span>Cargando</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2">
      <div class="pt-1 mx-6">
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <div class="overflow-auto flex-1">
            <div *ngIf="!modeTreeTrip" class="flex flex-col flex-1 min-h-0 overflow-auto"
              style="height: calc(100vh - 270px)">

              <table class="w-full bg-transparent" mat-table [dataSource]="dataSourceTrip" matSort
                #sortMainTable="matSort" matSortDisableClear multiTemplateDataRows>
                <!--
          
            <ng-container matColumnDef="det">
              <th mat-header-cell *matHeaderCellDef></th>
              <td *matCellDef="let row">
                <button
                  class="h-7 min-h-7 leading-6 px-2"
                  (click)="toggleDetails(row)"
                >
                  <mat-icon
                    class="icon-size-5"
                    [svgIcon]="
                      selectedMR?._id === row._id
                        ? 'heroicons_solid:chevron-up'
                        : 'heroicons_solid:chevron-down'
                    "
                  ></mat-icon>
                </button>
              </td>
            </ng-container>
      -->

                <!-- Viaje -->
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef class=" text-left text-sm"></th>
                  <td mat-cell *matCellDef="let element" class="text-left table-text  w-min-detail">
                    <mat-icon *ngIf="element.statusTripId == TripStatus.ABIERTO" svgIcon="heroicons_solid:check-circle"
                      matTooltip="Abierto" style="color:rgb(65, 106, 218); cursor: pointer;"></mat-icon>
                    <mat-icon *ngIf="element.statusTripId == TripStatus.CARGANDO" svgIcon="heroicons_solid:clock" matTooltip="Cargando"
                      style="color:rgb(236, 199, 58); cursor: pointer;"></mat-icon>
                    <mat-icon *ngIf="element.statusTripId == TripStatus.EN_PROCESO" svgIcon="heroicons_solid:clock" matTooltip="En proceso"
                      style="color:rgb(233, 124, 61);  cursor: pointer;"></mat-icon>
                    <mat-icon *ngIf="element.statusTripId == TripStatus.CERRADO" svgIcon="heroicons_solid:x-circle" matTooltip="Cerrado"
                      style="color:rgb(80, 77, 77); cursor: pointer;"></mat-icon>
                    <mat-icon *ngIf="element.statusTripId == TripStatus.FINALIZADO" svgIcon="heroicons_solid:check-circle"
                      matTooltip="Finalizado" style="color:rgb(9, 133, 50); cursor: pointer;"></mat-icon>
                    <mat-icon *ngIf="element.statusTripId == TripStatus.LIQUIDANDO" svgIcon="heroicons_solid:x-circle"
                      matTooltip="Liquidando" style="color:rgb(80, 2, 63); cursor: pointer;"></mat-icon>

                    <mat-icon *ngIf="element.statusTripId == TripStatus.DOC_LIQUIDACION_CREADO" svgIcon="heroicons_solid:check-circle"
                      matTooltip="Doc. Liquidación creado" style="color:rgb(19, 41, 141); cursor: pointer;"></mat-icon>
                    <mat-icon *ngIf="element.statusTripId == TripStatus.DOC_LIQUIDACION_APROBADO" svgIcon="heroicons_solid:check-circle"
                      matTooltip="Doc. Liquidación aprobado"
                      style="color:rgb(17, 125, 49); cursor: pointer;"></mat-icon>
                  </td>
                </ng-container>
                <ng-container matColumnDef="travel">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">
                    <p class="px-3">Viaje</p>
                  </th>
                  <td mat-cell *matCellDef="let data" class="text-secondary text-left text-uppercase text-sm">
                    <div class="flex items-center px-3 cursor-pointer" [ngClass]="{ 'underline': data.id }"
                      (click)="data.id && goToTravel(data)" [matTooltip]="data.id ? 'Ir al viaje' : ''">
                      <span>{{ data?.id }}</span>
                      <mat-icon *ngIf="data.id" class="ml-2 icon-size-3 hover:animate-bounce"
                        [svgIcon]="'heroicons_outline:rocket-launch'" style="color:rgb(0, 0, 0);"></mat-icon>
                    </div>
                  </td>
                </ng-container>

                <!-- Route & User Combined -->
                <ng-container matColumnDef="routeUser">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left text-sm">
                    Ruta - Usuario
                  </th>
                  <td mat-cell *matCellDef="let data" class="text-left table-text text-sm">
                    <app-user-route-display [routeData]="{
                      routeName: data?.subRoute?.name ?? '-',
                      externalKeys: { 
                        code: data?.subRoute?.externalKeys?.code ?? 
                              data?.route?.externalKeys?.code
                      }
                    }" [userData]="{
                      name: data?.user?.user_login?.username ?? 
                            data?.user ?? 
                            data?.username ?? '-'
                    }" [responsibleData]="{
                      name: data?.responsibleBusinessPartner?.name ?? 
                            data?.responsible?.name ?? '-',
                      personNumber: data?.responsibleBusinessPartner?.personNumber ?? 
                                   data?.responsible?.personNumber ?? '-',
                      externalKeys: { 
                        code: data?.responsibleBusinessPartner?.externalKeys?.code ?? 
                              data?.responsible?.externalKeys?.code ??
                              data?.responsible?.code
                      }
                    }" [displayMode]="'detailed'" [showRouteCode]="true" [showUser]="true" [showResponsible]="true">
                    </app-user-route-display>
                  </td>
                </ng-container>

                <!-- Conductor -->
                <ng-container matColumnDef="businessPartner">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-left">
                    Responsable
                  </th>
                  <td mat-cell *matCellDef="let data" class="text-left table-text">
                    <span class="table-text-code font-semibold">{{
                      data?.businessPartner?.code
                      }}</span><br />
                    {{ data?.businessPartner?.name ?? "-" }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="info">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left text-sm">
                    Ruta
                  </th>
                  <td mat-cell *matCellDef="let data" class="text-left table-text text-sm"
                    [matTooltip]="getTooltip(data)" matTooltipClass="info-tooltip" matTooltipShowDelay="300"
                    matTooltipPosition="above">
                    <div class="table-text-m">
                      <!-- Ruta -->
                      <div *ngIf="data.subRoute">
                        <span class="table-text-code font-semibold uppercase">
                          {{ data?.subRoute?.externalKeys?.code ?? data?.subRoute?.model ?? "-" }}
                        </span><br />
                        {{ data?.subRoute?.name ?? "-" }}
                      </div>

                      <!-- Usuario -->
                      <div *ngIf="data?.user?.user_login?.username" class="mt-1">
                        <strong>Usuario:</strong><br>
                        <span>{{ data?.user?.user_login?.username }}</span>
                      </div>

                      <!-- Responsable -->
                      <div *ngIf="data?.businessPartner?.code || data?.businessPartner?.name" class="mt-1">
                        <strong>Respons. :</strong>
                        <span class="table-text-code font-semibold">
                          {{ data?.businessPartner?.code ?? "" }}
                        </span><br>
                        <span>{{ data?.businessPartner?.name ?? "-" }}</span>
                      </div>
                    </div>
                  </td>
                </ng-container>

                <!-- Inicio -->
                <ng-container matColumnDef="start">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-left">
                    Inicio
                  </th>
                  <td mat-cell *matCellDef="let data" class="text-left text-sm">
                    <p class="pr-2">
                      <span class="font-semibold" [matTooltip]="'Tiempo teórico'">T: </span>
                      {{
                      data?.dateHourStartTeoric
                      ? (data?.dateHourStartTeoric | date: 'dd-MM-yyyy HH:mm')
                      : "-"
                      }}
                    </p>
                    <p class="pr-2">
                      <span class="font-semibold" [matTooltip]="'Tiempo real'">R: </span>
                      {{
                      data?.dateHourStart
                      ? (data?.dateHourStart | date: 'dd-MM-yyyy HH:mm')
                      : "-"
                      }}
                    </p>
                  </td>
                </ng-container>

                <!-- Fin -->
                <ng-container matColumnDef="end">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">
                    Fin
                  </th>
                  <td mat-cell *matCellDef="let data" class="text-left text-sm">
                    <p class="pr-2">
                      <span class="font-semibold">T: </span>
                      {{
                      data?.dateHourEndTeoric
                      ? (data?.dateHourEndTeoric | date: 'dd-MM-yyyy HH:mm')
                      : "-"
                      }}
                    </p>
                    <p class="pr-2">
                      <span class="font-semibold">R: </span>
                      {{
                      data?.dateHourEnd
                      ? (data?.dateHourEnd | date: 'dd-MM-yyyy HH:mm')
                      : "-"
                      }}
                    </p>
                  </td>
                </ng-container>

                <!-- Fecha de carga -->
                <ng-container matColumnDef="dateChare">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-left">
                    Fecha de Carga
                  </th>
                  <td mat-cell *matCellDef="let data" class="text-left text-sm">
                    <p> {{
                      data?.loadDateTime
                      ? (data?.loadDateTime | date: 'dd-MM-yyyy HH:mm')
                      : "-"
                      }}</p>
                  </td>
                </ng-container>

                <!-- Vehículo -->
                <ng-container matColumnDef="vehicle">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-left">
                    Vehículo
                  </th>
                  <td mat-cell *matCellDef="let data" class="text-left table-text">
                    <span class="table-text-code font-semibold">{{
                      data?.vehicle?.plate
                      }}</span><br />
                    {{ data?.vehicle?.name ?? "-" }}
                  </td>
                </ng-container>

                <!--  Estado -->
                <ng-container matColumnDef="state">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-left">
                    <p class="px-6">Estado</p>
                  </th>
                  <td mat-cell *matCellDef="let data" class="text-left text-sm">
                    <div class="px-6">
                      <app-trip-status-badge [statusTripId]="data?.statusTripId"></app-trip-status-badge>
                    </div>
                  </td>
                </ng-container>

                <!-- Documentos de carga unificados -->
                <ng-container matColumnDef="hasUnifiedLoadDocs">
                  <th mat-header-cell *matHeaderCellDef class="text-center">
                    <mat-icon svgIcon="heroicons_outline:document-duplicate"
                      class="text-gray-400" matTooltip="Documentos de carga unificados"></mat-icon>
                  </th>
                  <td mat-cell *matCellDef="let data" class="text-center">
                    <app-unified-load-docs-chip [hasUnifiedLoadDocs]="data?.hasUnifiedLoadDocs"></app-unified-load-docs-chip>
                  </td>
                </ng-container>

                <!-- Acciones -->
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                  <td mat-cell *matCellDef="let row" class="px-6 py-3 text-left">
                    <div class="flex items-center gap-2">
                      <div class="w-6 flex justify-center">
                        <mat-icon *ngIf="row?.createdBySession" svgIcon="heroicons_solid:user-circle"
                          [matTooltip]="getCreatedTooltip(row)" style="color: rgb(65, 106, 218); cursor: pointer;">
                        </mat-icon>
                      </div>
                      <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                        <mat-icon>more_vert</mat-icon>
                      </button>
                    </div>

                    <mat-menu #actionMenu="matMenu">
                      <button mat-menu-item (click)="openEditModal(row)">
                        <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                        Editar
                      </button>
                      <button *canPermissionsOnly="PERMISSIONS.DELIVERY_STATUS_MONITOR.AUDIT_LOG" mat-menu-item (click)="openAuditLog(row)">
                        <mat-icon>history</mat-icon>
                        Ver Bitácora
                      </button>
                    </mat-menu>
                  </td>
                </ng-container>

                <!--
            <ng-container matColumnDef="expandedDetail">
              <td
                mat-cell
                *matCellDef="let row"
                [attr.colspan]="displayColums.length"
              >
                <ng-container *ngIf="selectedMR?._id === row?._id">
                  <ng-container
                    *ngTemplateOutlet="
                      rowDetailsTemplate;
                      context: { $implicit: row }
                    "
                  ></ng-container>
                </ng-container>
              </td>
            </ng-container> 
          -->

                <!-- Header Row -->
                <tr mat-header-row *matHeaderRowDef="displayColums" class="sticky top-0 z-10 bg-white"></tr>

                <!-- Fila Principal -->
                <tr mat-row *matRowDef="let row; columns: displayColums" class="order-row h-16"></tr>
                <!-- [class.table-expanded-row]="selectedMR?._id === row?._id"
      <tr
              mat-row
              *matRowDef="let row; columns: ['expandedDetail']"
              class="table-detail-row"
            ></tr>      
  -->
              </table>

            </div>
            <!-- Vista árbol -->
            <div *ngIf="modeTreeTrip === 'statusTrip' || modeTreeTrip === 'functionTrip'"
              class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
              <div class="overflow-auto flex-1">
                <table class="w-full bg-transparent" mat-table [dataSource]="dataSourceTreeTrip" matSort
                  #sortTreeTable="matSort" matSortDisableClear multiTemplateDataRows>

                  <!-- Columna de expansión para árbol -->
                  <ng-container matColumnDef="det">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let row">
                      <div class="flex items-center">
                        <!-- nodos padre -->
                        <button mat-icon-button [style.visibility]="!hasChild(0, row) ? 'hidden' : ''"
                          [style.marginLeft.px]="getLevel(row) * 20" (click)="treeControl.toggle(row)">
                          <mat-icon color="primary">
                            {{treeControl.isExpanded(row) ? 'expand_more' : 'chevron_right'}}
                          </mat-icon>
                        </button>
                      </div>
                    </td>
                  </ng-container>

                  <!-- ID -->
                  <ng-container matColumnDef="travel">
                    <th mat-header-cell *matHeaderCellDef>
                      {{ modeTreeTrip === 'statusTrip' ? 'Viaje'
                      : modeTreeTrip === 'functionTrip' ? 'Viaje'
                      : 'Viaje' }}
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <div class="flex items-center gap-2">
                        <!-- Para nodos padre (grupos) -->
                        <div *ngIf="hasChild(0, row)" class="flex items-center gap-2">
                          <!-- ÍCONO para statusTrip -->
                          <mat-icon *ngIf="modeTreeTrip === 'statusTrip'" [svgIcon]="getGroupIcon(row)"
                            [style.color]="getGroupColor(row)" class="icon-size-4">
                          </mat-icon>
                          <span class="font-bold text-sm">{{ getGroupName(row) }}</span>
                          <span class="text-sm text-gray-500 font-bold">({{ row.children?.length || 0 }})</span>
                        </div>

                        <!-- Para nodos hijo (viajes individuales) -->
                        <div *ngIf="!hasChild(0, row)" class="flex items-center gap-2">
                          <span class="text-sm">{{ row?.id }}</span>
                          <mat-icon *ngIf="row.id" class="ml-2 icon-size-3"
                            [svgIcon]="'heroicons_outline:rocket-launch'" (click)="row.id && goToTravel(row)"
                            [class.cursor-pointer]="row.id" [class.hover:animate-bounce]="row.id"
                            style="color:rgb(0, 0, 0);">
                          </mat-icon>
                        </div>
                      </div>
                    </td>
                  </ng-container>

                  <!-- Ruta - Usuario (solo para nodos hijo) -->
                  <ng-container matColumnDef="routeUser">
                    <th mat-header-cell *matHeaderCellDef class="text-left text-sm">
                      Ruta - Usuario
                    </th>
                    <td mat-cell *matCellDef="let data" class="text-left table-text text-sm">
                      <div *ngIf="!hasChild(0, data)">
                        <app-user-route-display [routeData]="{
                            routeName: data?.subRoute?.name ?? '-',
                            externalKeys: { 
                              code: data?.subRoute?.externalKeys?.code ?? 
                                    data?.route?.externalKeys?.code
                            }
                          }" [userData]="{
                            name: data?.user?.user_login?.username ?? 
                                  data?.user ?? 
                                  data?.username ?? '-'
                          }" [responsibleData]="{
                            name: data?.responsibleBusinessPartner?.name ?? 
                                  data?.responsible?.name ?? '-',
                            personNumber: data?.responsibleBusinessPartner?.personNumber ?? 
                                         data?.responsible?.personNumber ?? '-',
                            externalKeys: { 
                              code: data?.responsibleBusinessPartner?.externalKeys?.code ?? 
                                    data?.responsible?.externalKeys?.code ??
                                    data?.responsible?.code
                            }
                          }" [displayMode]="'detailed'" [showRouteCode]="true" [showUser]="true"
                          [showResponsible]="true">
                        </app-user-route-display>
                      </div>
                    </td>
                  </ng-container>


                  <ng-container matColumnDef="start">
                    <th mat-header-cell *matHeaderCellDef class="text-left">Inicio</th>
                    <td mat-cell *matCellDef="let data" class="text-left text-sm">
                      <div *ngIf="!hasChild(0, data)">
                        <p class="pr-2">
                          <span class="font-semibold">T: </span>
                          {{ data?.dateHourStartTeoric ? (data?.dateHourStartTeoric | date: 'dd-MM-yyyy HH:mm') : "-" }}
                        </p>
                        <p class="pr-2">
                          <span class="font-semibold">R: </span>
                          {{ data?.dateHourStart ? (data?.dateHourStart | date: 'dd-MM-yyyy HH:mm') : "-" }}
                        </p>
                      </div>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="end">
                    <th mat-header-cell *matHeaderCellDef class="text-left">Fin</th>
                    <td mat-cell *matCellDef="let data" class="text-left text-sm">
                      <div *ngIf="!hasChild(0, data)">
                        <p class="pr-2">
                          <span class="font-semibold">T: </span>
                          {{ data?.dateHourEndTeoric ? (data?.dateHourEndTeoric | date: 'dd-MM-yyyy HH:mm') : "-" }}
                        </p>
                        <p class="pr-2">
                          <span class="font-semibold">R: </span>
                          {{ data?.dateHourEnd ? (data?.dateHourEnd | date: 'dd-MM-yyyy HH:mm') : "-" }}
                        </p>
                      </div>
                    </td>
                  </ng-container>
                  <!-- Fecha de carga -->
                  <ng-container matColumnDef="dateChare">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-left">
                      Fecha de Carga
                    </th>
                    <td mat-cell *matCellDef="let data" class="text-left text-sm">
                      <div *ngIf="!hasChild(0, data)">
                        <p>{{
                          data?.loadDateTime
                          ? (data?.loadDateTime | date: 'dd-MM-yyyy HH:mm')
                          : "-"
                          }}</p>
                      </div>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="vehicle">
                    <th mat-header-cell *matHeaderCellDef class="text-left">Vehículo</th>
                    <td mat-cell *matCellDef="let data" class="text-left table-text">
                      <div *ngIf="!hasChild(0, data)">
                        <span class="table-text-code font-semibold">{{ data?.vehicle?.plate }}</span><br />
                        {{ data?.vehicle?.name ?? "-" }}
                      </div>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="state">
                    <th mat-header-cell *matHeaderCellDef class="text-left">Estado</th>
                    <td mat-cell *matCellDef="let data" class="text-left text-sm">
                      <div *ngIf="!hasChild(0, data)">
                        <app-trip-status-badge [statusTripId]="data?.statusTripId"></app-trip-status-badge>
                      </div>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                    <td mat-cell *matCellDef="let row" class="px-6 py-3 text-left">
                      <div *ngIf="!hasChild(0, row)">
                        <div class="flex items-center gap-2">
                          <div class="w-6 flex justify-center">
                            <mat-icon *ngIf="row?.createdBySession" svgIcon="heroicons_solid:user-circle"
                              [matTooltip]="getCreatedTooltip(row)" style="color: rgb(65, 106, 218); cursor: pointer;">
                            </mat-icon>
                          </div>
                          <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                            <mat-icon>more_vert</mat-icon>
                          </button>
                        </div>
                        <mat-menu #actionMenu="matMenu">
                          <button mat-menu-item (click)="openEditModal(row)">
                            <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                            Editar
                          </button>
                          <button *canPermissionsOnly="PERMISSIONS.DELIVERY_STATUS_MONITOR.AUDIT_LOG" mat-menu-item (click)="openAuditLog(row)">
                            <mat-icon>history</mat-icon>
                            Ver Bitácora
                          </button>
                        </mat-menu>
                      </div>
                    </td>
                  </ng-container>
                  <!-- Header Row -->
                  <tr mat-header-row *matHeaderRowDef="displayColumsTree" class="sticky top-0 z-10 bg-white"></tr>
                  <!-- Filas -->
                  <tr mat-row *matRowDef="let row; columns: displayColumsTree" class="order-row h-16"
                    [class.font-bold]="hasChild(0, row)"
                    [class.bg-gray-50]="hasChild(0, row) && modeTreeTrip === 'statusTrip'"
                    [class.bg-blue-50]="hasChild(0, row) && modeTreeTrip === 'functionTrip'">
                  </tr>
                </table>
              </div>
            </div>
            <div *ngIf="this.dataSourceTrip?.data?.length === 0" class="p-8 text-center text-1xl sm:p-10">
              Lo sentimos, no hay registros para mostrar.
            </div>
          </div>
        </div>
        <!-- Paginación -->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 sticky bottom-0">
          <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
            [pageSize]="pageSize" (page)="onPageChange($event)"></mat-paginator>
        </div>
      </div>

    </div>
  </div>

  <!-- Modal crear -->
  <ng-template #addModal let-data>
    <h2 mat-dialog-title class="text-lg font-bold mb-1">Nuevo Registro</h2>
    <mat-dialog-content class="modal-content">
      <!-- Configuración de Fechas -->
      <app-form-section title="Configuración de Fechas" icon="calendar_today" iconColor="blue">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <!-- Fecha de Inicio de Viaje -->
          <mat-form-field appearance="fill" class="col-span-1">
            <mat-label>Fecha de Inicio del Viaje</mat-label>
            <input matInput [(ngModel)]="currentCreateTrip.dateHourStartTeoric" name="dateHourStartTeoric"
              [min]="minDate" required [matDatepicker]="pickerStart" (ngModelChange)="onChangeCreateStarTrip($event)" />
            <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
            <mat-datepicker #pickerStart></mat-datepicker>
          </mat-form-field>

          <!-- Fecha de Fin de Viaje -->
          <mat-form-field appearance="fill" class="col-span-1">
            <mat-label>Fecha de Fin del Viaje</mat-label>
            <input matInput [(ngModel)]="currentCreateTrip.dateHourEndTeoric" name="dateHourEndTeoric" required
              [min]="minDateEnd" [matDatepicker]="pickerEnd" />
            <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
            <mat-datepicker #pickerEnd></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
          <!-- Fecha de Carga-->
          <mat-form-field appearance="fill" class="col-span-1">
            <mat-label>Fecha de Carga</mat-label>
            <input matInput [(ngModel)]="currentCreateTrip.loadDateTime" name="loadDateTime" [max]="minDateEnd" required
              [matDatepicker]="pickerLoad" />
            <mat-datepicker-toggle matSuffix [for]="pickerLoad"></mat-datepicker-toggle>
            <mat-datepicker #pickerLoad></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="fill" class="col-span-1">
            <mat-label>Hora de Carga</mat-label>
            <mat-icon matSuffix>schedule</mat-icon>
            <input matInput [(ngModel)]="currentCreateTrip.time" name="time" placeholder="Inicio" [min]="minTime"
              [ngxTimepicker]="default2" />
            <ngx-material-timepicker #default2></ngx-material-timepicker>
          </mat-form-field>
        </div>
      </app-form-section>

      <!-- Asignaciones -->
      <app-form-section title="Asignaciones" icon="assignment_ind" iconColor="green">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="col-span-1">
            <label>Ruta</label>
            <ng-select [(ngModel)]="currentCreateTrip.subRouteId" [items]="routeListGeneral" bindLabel="name"
              bindValue="_id" [searchable]="true" placeholder="Seleccione una Ruta" name="subRouteId"
              [appendTo]="'body'">
              <ng-template ng-label-tmp let-item="item">
                <span class="text-sm"><b>{{ item?.externalKeys?.code }}</b> - {{ item?.name }}</span>
              </ng-template>

              <ng-template ng-option-tmp let-item="item">
                <span class="text-sm"><b>{{ item?.externalKeys?.code }}</b> - {{ item?.name }}</span>
              </ng-template>
            </ng-select>
          </div>
          <div class="col-span-1">
            <label>Vehículo</label>
            <ng-select [(ngModel)]="currentCreateTrip.vehicleId" [items]="vechicleListGeneral" bindLabel="name"
              bindValue="_id" [searchable]="true" placeholder="Seleccione un vehículo" name="vehicleId"
              [appendTo]="'body'">
              <ng-template ng-label-tmp let-item="item">
                <span class="text-sm"><b>{{ item?.externalKeys?.code }}</b> - {{ item?.name }}</span>
              </ng-template>

              <ng-template ng-option-tmp let-item="item">
                <span class="text-sm"><b>{{ item?.externalKeys?.code }}</b> - {{ item?.name }}</span>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </app-form-section>
    </mat-dialog-content>
    <mat-dialog-actions class="modal-actions flex justify-between">
      <button mat-button mat-dialog-close class="align-left">Cancelar</button>
      <button [disabled]="!isValidateFormCreate" mat-raised-button color="primary" (click)="fechCreateTrip()">
        Guardar
      </button>
    </mat-dialog-actions>
  </ng-template>
  <!-- Modal editar -->
  <ng-template #editModal let-data>
    <h2 mat-dialog-title class="text-lg font-bold mb-1">
      Editar Registro
    </h2>
    <mat-dialog-content class="modal-content-update">
      <!-- Mensaje informativo cuando el modal está en modo solo lectura -->
      <div *ngIf="!canEditBasicFields" class="bg-orange-50 border-l-4 border-orange-400 p-4 mb-4">
        <div class="flex">
          <div class="flex-shrink-0">
            <mat-icon class="text-orange-400">lock</mat-icon>
          </div>
          <div class="ml-3">
            <p class="text-sm text-orange-700">
              <strong>Modo Solo Lectura:</strong> Este viaje no está en estado "Abierto".
              No se pueden realizar modificaciones hasta que el viaje retorne al estado "Abierto".
            </p>
          </div>
        </div>
      </div>

      <!-- Configuración de Fechas -->
      <app-form-section title="Configuración de Fechas" icon="calendar_today" iconColor="blue">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <!-- Fecha de Inicio de Viaje -->
          <mat-form-field appearance="fill" class="col-span-1">
            <mat-label>Fecha de Inicio del Viaje</mat-label>
            <input matInput [(ngModel)]="currentUpdateTrip.dateHourStartTeoric" name="dateHourStartTeoricEdit" required
              [disabled]="!canEditBasicFields" [matDatepicker]="pickerStartEdit"
              (ngModelChange)="onChangeUpdateStarTrip($event)" />
            <mat-datepicker-toggle matSuffix [for]="pickerStartEdit"
              [disabled]="!canEditBasicFields"></mat-datepicker-toggle>
            <mat-datepicker #pickerStartEdit [disabled]="!canEditBasicFields"></mat-datepicker>
          </mat-form-field>

          <!-- Fecha de Fin de Viaje -->
          <mat-form-field appearance="fill" class="col-span-1">
            <mat-label>Fecha de Fin del Viaje</mat-label>
            <input matInput [(ngModel)]="currentUpdateTrip.dateHourEndTeoric" name="dateHourEndTeoricEdit" required
              [disabled]="!canEditBasicFields" [matDatepicker]="pickerEndEdit" />
            <mat-datepicker-toggle matSuffix [for]="pickerEndEdit"
              [disabled]="!canEditBasicFields"></mat-datepicker-toggle>
            <mat-datepicker #pickerEndEdit [disabled]="!canEditBasicFields"></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
          <!-- Fecha de Carga-->
          <mat-form-field appearance="fill" class="col-span-1">
            <mat-label>Fecha de Carga</mat-label>
            <input matInput [(ngModel)]="currentUpdateTrip.loadDateTime" name="loadDateTimeEdit" required
              [disabled]="!canEditBasicFields" [matDatepicker]="pickerLoadEdit" />
            <mat-datepicker-toggle matSuffix [for]="pickerLoadEdit"
              [disabled]="!canEditBasicFields"></mat-datepicker-toggle>
            <mat-datepicker #pickerLoadEdit [disabled]="!canEditBasicFields"></mat-datepicker>
            <mat-hint *ngIf="!canEditBasicFields" class="text-orange-600">
              <mat-icon class="icon-size-4 mr-1">lock</mat-icon>
              Campo bloqueado: El viaje no está en estado "Abierto"
            </mat-hint>
          </mat-form-field>

          <mat-form-field appearance="fill" class="col-span-1">
            <mat-label>Hora de Carga</mat-label>
            <mat-icon matSuffix>schedule</mat-icon>
            <input matInput [(ngModel)]="currentUpdateTrip.time" name="timeEdit" placeholder="Hora"
              [disabled]="!canEditBasicFields" [ngxTimepicker]="timePickerEdit" />
            <ngx-material-timepicker #timePickerEdit [disabled]="!canEditBasicFields"></ngx-material-timepicker>
            <mat-hint *ngIf="!canEditBasicFields" class="text-orange-600">
              <mat-icon class="icon-size-4 mr-1">lock</mat-icon>
              Campo bloqueado: El viaje no está en estado "Abierto"
            </mat-hint>
          </mat-form-field>
        </div>
      </app-form-section>

      <!-- Asignaciones -->
      <app-form-section title="Asignaciones" icon="assignment_ind" iconColor="green">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="col-span-1">
            <label>Usuario</label>
            <ng-select [(ngModel)]="currentUpdateTrip.masterUserId" [items]="userMasterList"
              bindLabel="user_login_username" bindValue="_id" [searchable]="true" placeholder="Seleccione el usuario"
              name="masterUserId" [appendTo]="'body'" [disabled]="!canEditBasicFields">
              <ng-template ng-label-tmp let-item="item">
                <span>
                  {{ item?.user_login_username }}
                  <ng-container *ngIf="item?.businessPartnerName"> - {{ item?.businessPartnerName }}</ng-container>
                </span>
              </ng-template>

              <ng-template ng-option-tmp let-item="item">
                <span>
                  {{ item?.user_login_username }}
                  <ng-container *ngIf="item?.businessPartnerName"> - {{ item?.businessPartnerName }}</ng-container>
                </span>
              </ng-template>
            </ng-select>
          </div>

          <div class="col-span-1">
            <label>Vehículo</label>
            <ng-select [(ngModel)]="currentUpdateTrip.vehicleId" [items]="vechicleListGeneral" bindLabel="name"
              bindValue="_id" [searchable]="true" placeholder="Seleccione un vehículo" name="vehicleId"
              [appendTo]="'body'" [disabled]="!canEditBasicFields">
              <ng-template ng-label-tmp let-item="item">
                <span class="text-sm"><b>{{ item?.externalKeys?.code }}</b> - {{ item?.name }}</span>
              </ng-template>

              <ng-template ng-option-tmp let-item="item">
                <span class="text-sm"><b>{{ item?.externalKeys?.code }}</b> - {{ item?.name }}</span>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </app-form-section>

      <!-- Estado del Viaje -->
      <app-form-section title="Estado del Viaje" icon="flag" iconColor="orange">
        <div class="grid grid-cols-1 gap-4">
          <div class="col-span-1">
            <label>Estado de Viaje</label>
            <ng-select [(ngModel)]="currentUpdateTrip.statusTripId" [items]="statusList" bindLabel="value"
              bindValue="code" [searchable]="true" placeholder="Seleccione un Estado" name="statusId"
              [appendTo]="'body'" [disabled]="!canEditBasicFields">
              <ng-template ng-label-tmp let-item="item">
                <span class="text-sm text-uppercase"> {{ item?.value }}</span>
              </ng-template>

              <ng-template ng-option-tmp let-item="item">
                <span class="text-sm text-uppercase">{{ item?.value }}</span>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </app-form-section>
    </mat-dialog-content>
    <mat-dialog-actions class="modal-actions flex justify-between">
      <button mat-button mat-dialog-close class="align-left">Cancelar</button>
      <button *ngIf="canEditBasicFields" [disabled]="!isValidateFormUpdate" mat-raised-button color="primary"
        (click)="saveChanges()">
        Guardar
      </button>
      <button *ngIf="!canEditBasicFields" mat-raised-button color="primary" mat-dialog-close>
        Cerrar
      </button>
    </mat-dialog-actions>
  </ng-template>

  <app-filter *ngIf="isAcive" (onFilterEvent)="handleFilterSearch()" (onCleanEvent)="handleFilterClean()">
    <form [formGroup]="form">
      <app-filter-section title="Rango de fechas" [expanded]="true">
        <app-dates-filters [form]="form" [submitted]="submitted" [showStartTrip]="true" [showEndTrip]="true"
          [showUploadTripDateRange]="true" />
      </app-filter-section>

      <app-filter-section title="Configuración" [expanded]="false">
        <app-configuration-filters [form]="form" [company]="true" [officeGroup]="true"
          [salesOffice]="true"></app-configuration-filters>
      </app-filter-section>

      <app-filter-section title="Socios de Negocio" [expanded]="false">
        <app-business-partners-filters [form]="form"
          [assignedUserByBusinessPartnerId]="true"></app-business-partners-filters>
      </app-filter-section>

      <app-filter-section title="Gestión de rutas" [expanded]="false">
        <app-routes-filters [form]="form" [type]="true" [routeGroup]="true" [route]="true"></app-routes-filters>
      </app-filter-section>

      <app-filter-section title="Documentos de carga" [expanded]="false">
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Docs. carga unificados</mat-label>
          <mat-select formControlName="hasUnifiedLoadDocs">
            <mat-option [value]="null">Todos</mat-option>
            <mat-option [value]="true">Sí</mat-option>
            <mat-option [value]="false">No</mat-option>
          </mat-select>
        </mat-form-field>
      </app-filter-section>
    </form>
  </app-filter>
</mat-sidenav-container>